var render = function() {
  var _obj, _obj$1
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { "data-wd": "sidenav" } },
    [
      _c("div", {
        class:
          ((_obj = {}),
          (_obj[_vm.$style.screen] = true),
          (_obj[_vm.$style.screenHidden] = !_vm.isOpen),
          _obj),
        attrs: { "data-wd": "screen" },
        on: { click: _vm.close }
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "ui sidebar vertical menu visible",
          class:
            ((_obj$1 = {}),
            (_obj$1[_vm.$style.elHidden] = !_vm.isOpen),
            (_obj$1[_vm.$style.el] = true),
            _obj$1)
        },
        [
          _c(
            "div",
            { staticClass: "item" },
            [
              _c(
                "router-link",
                {
                  class: _vm.$style.logoAnchor,
                  attrs: { to: { name: "home" }, "data-wd": "logo" },
                  nativeOn: {
                    click: function($event) {
                      return _vm.close.apply(null, arguments)
                    }
                  }
                },
                [
                  _c("img", {
                    attrs: {
                      src: require("../assets/images/logo.png"),
                      alt: _vm.$t("terms.readgraphyLogo")
                    }
                  })
                ]
              ),
              _vm._v(" "),
              _c("h1", { class: _vm.$style.title }, [
                _vm._v(
                  "\n        " + _vm._s(_vm.$t("terms.readgraphy")) + "\n      "
                )
              ])
            ],
            1
          ),
          _vm._v(" "),
          _vm.isLoggedIn
            ? _c("div", { staticClass: "item" }, [
                _vm.isCustomer
                  ? _c("div", { class: _vm.$style.badge }, [
                      _c("span", { class: _vm.$style.badgeTitle }, [
                        _vm._v(
                          _vm._s(_vm.$t("terms.paidPlan")) + "\n          "
                        ),
                        _vm.isEarlybird
                          ? _c("span", [
                              _vm._v(
                                "(" + _vm._s(_vm.$t("terms.earlybird")) + ")"
                              )
                            ])
                          : _vm._e()
                      ])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  { class: _vm.$style.email, attrs: { "data-wd": "email" } },
                  [_vm._v("\n        " + _vm._s(_vm.user.email) + "\n      ")]
                ),
                _vm._v(" "),
                _vm.purchaserReceived && !_vm.isCustomer
                  ? _c(
                      "div",
                      { class: _vm.$style.upgrade },
                      [
                        _c(
                          "router-link",
                          {
                            staticClass: "ui inverted green button mini",
                            attrs: {
                              to: { name: "plans" },
                              "data-wd": "plans"
                            },
                            nativeOn: {
                              click: function($event) {
                                return _vm.closeWithLog.apply(null, arguments)
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm._f("cap")(_vm.$t("terms.upgrade"))) +
                                "\n        "
                            )
                          ]
                        )
                      ],
                      1
                    )
                  : _vm._e()
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("nav", { attrs: { role: "navigation" } }, [
            _vm.isLoggedIn
              ? _c("ul", { class: _vm.$style.firstList }, [
                  _c(
                    "li",
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "item",
                          attrs: {
                            to: { name: "library" },
                            "data-wd": "library"
                          },
                          nativeOn: {
                            click: function($event) {
                              return _vm.close.apply(null, arguments)
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm._f("cap")(_vm.$t("terms.myLibrary"))) +
                              "\n          "
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "li",
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "item",
                          attrs: { to: { name: "notelists" } },
                          nativeOn: {
                            click: function($event) {
                              _vm.$fa.logEvent(_vm.$fa.Event.CLICK_NOTELISTS)
                              _vm.close()
                            }
                          }
                        },
                        [
                          _c(
                            "span",
                            {
                              directives: [
                                {
                                  name: "new-feature",
                                  rawName: "v-new-feature",
                                  value: { id: "notelists", target: "parent" },
                                  expression:
                                    "{ id: 'notelists', target: 'parent' }"
                                }
                              ]
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm._f("cap")(_vm.$t("terms.notelists"))
                                  ) +
                                  "\n            "
                              )
                            ]
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "li",
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "item",
                          attrs: {
                            to: { name: "tagManager" },
                            "data-wd": "tagManager"
                          },
                          nativeOn: {
                            click: function($event) {
                              return _vm.close.apply(null, arguments)
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm._f("cap")(_vm.$tc("terms.tag", 2))) +
                              "\n          "
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "li",
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "item",
                          attrs: {
                            to: { name: "charts" },
                            "data-wd": "charts"
                          },
                          nativeOn: {
                            click: function($event) {
                              _vm.$fa.logEvent(_vm.$fa.Event.CLICK_CHARTS)
                              _vm.close()
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm._f("cap")(_vm.$t("terms.charts"))) +
                              "\n          "
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "li",
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "item",
                          attrs: {
                            to: { name: "settings" },
                            "data-wd": "settings"
                          },
                          nativeOn: {
                            click: function($event) {
                              return _vm.close.apply(null, arguments)
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm._f("cap")(_vm.$t("terms.setting"))) +
                              "\n          "
                          )
                        ]
                      )
                    ],
                    1
                  )
                ])
              : _c("ul", { class: _vm.$style.firstList }, [
                  _c(
                    "li",
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "item",
                          attrs: {
                            to: { name: "signin" },
                            "data-wd": "signin"
                          },
                          nativeOn: {
                            click: function($event) {
                              return _vm.close.apply(null, arguments)
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm._f("cap")(_vm.$t("terms.login"))) +
                              "\n          "
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "li",
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "item",
                          attrs: {
                            to: { name: "signup" },
                            "data-wd": "signup"
                          },
                          nativeOn: {
                            click: function($event) {
                              return _vm.close.apply(null, arguments)
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm._f("cap")(_vm.$t("terms.signup"))) +
                              "\n          "
                          )
                        ]
                      )
                    ],
                    1
                  )
                ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "ui divider" }),
          _vm._v(" "),
          _c("ul", [
            _c(
              "li",
              [
                _c(
                  "router-link",
                  {
                    staticClass: "item",
                    attrs: { to: { name: "plans" }, "data-wd": "plans" },
                    nativeOn: {
                      click: function($event) {
                        return _vm.close.apply(null, arguments)
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm._f("cap")(_vm.$t("terms.planInfo"))) +
                        "\n        "
                    )
                  ]
                )
              ],
              1
            ),
            _vm._v(" "),
            _c("li", [
              _c(
                "a",
                {
                  staticClass: "item",
                  attrs: { "data-wd": "feedback" },
                  on: { click: _vm.openFeedback }
                },
                [_vm._v(_vm._s(_vm._f("cap")(_vm.$t("terms.feedback"))))]
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "ui divider" }),
          _vm._v(" "),
          _c("div", { class: _vm.$style.version }, [
            _c("span", { staticClass: "item" }, [
              _vm._v("v" + _vm._s(_vm.version))
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _vm.shownDialog
        ? _c("dialog-feedback", {
            on: { cancel: _vm.closeFeedback, confirm: _vm.completeFeedback }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }